import { render } from "./Post5.vue?vue&type=template&id=bc431674"
import script from "./Post5.vue?vue&type=script&lang=js"
export * from "./Post5.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\simon\\OneDrive\\Bureau\\Web\\institut-hugo\\institut-hugo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__